import React from 'react';
import '../assets/css/BlogSkeleton.css';

const BlogDetailsSkeleton = () => {
  return (
    <div className="blog-details-skeleton">
      {/* Title skeleton */}
      <div className="skeleton-title"></div>
      
      {/* Image skeleton */}
      <div className="skeleton-image"></div>
      
      {/* Content skeleton */}
      <div className="skeleton-content">
        <div className="skeleton-line"></div>
        <div className="skeleton-line medium"></div>
        <div className="skeleton-line short"></div>
        <div className="skeleton-line"></div>
        <div className="skeleton-line medium"></div>
        <div className="skeleton-line"></div>
        <div className="skeleton-line short"></div>
        <div className="skeleton-line"></div>
        <div className="skeleton-line medium"></div>
      </div>
      
      {/* Navigation skeleton */}
      <div className="skeleton-navigation">
        <div className="skeleton-nav-item"></div>
        <div className="skeleton-nav-item"></div>
      </div>
    </div>
  );
};

export default BlogDetailsSkeleton;
